'use strict'
import request from '@/utils/request'
class ProjectService{
    static deletephotoproject(query){
        return request({
            url:'/projects/deletephotoproject',
            method:'delete',
            params:query
        })
    }
    static getphotosproject(query){
        return request({
            url:'/projects/getphotosproject',
            method:'get',
            params:query
        })
    }
    static limituploadphotoproject(query){
        return request({
            url:'/projects/limituploadphotoproject',
            method:'get',
            params:query
        })
    }
    static savephotosproject(data){
        return request({
            url:'/projects/savephotosproject',
            method:'post',
            data
        })
    }
    static editproductquantity(data){
        return request({
            url:'/projects/editproductquantity',
            method:'put',
            data
        })
    }
    static editdescriptionproject(data){
        return request({
            url:'/projects/editdescriptionproject',
            method:'put',
            data
        })
    }
    static getdataproject(query){
        return request({
            url:'/projects/getdataproject',
            method:'get',
            params:query
        })
    }
    static editnameproject(data){
        return request({
            url:'/projects/editnameproject',
            method:'put',
            data
        })
    }
    static editpriceproduct(data){
        return request({
            url:'/projects/editpriceproduct',
            method:'put',
            data
        })
    }
    static changeproductstatus(data){
        return request({
            url:'/projects/changeproductstatus',
            method:'put',
            data
        })
    }
    static changesalesstatus(data){
        return request({
            url:'/projects/changesalesstatus',
            method:'put',
            data
        })
    }
    static getfiveprojectindex(data){
        return request({
            url:'/projects/getfiveprojectindex',
            method:'post',
            data
        })
    }
    static createproject(data){
        return request({
            url:'/projects/createproject',
            method:'post',
            data
        })
    }
    static editproject(data){
        return request({
            url:'/projects/editproject',
            method:'put',
            data
        })
    }
    static paginatesearchedprojects(query){
        return request({
            url:'/projects/paginatesearchedprojects',
            method:'get',
            params:query
        })
    }
    static getallprojects(query){
        return request({
            url:'/projects/getallprojects',
            method:'get',
            params:query
        })
    }
    static getdatauserprofile(query){
        return request({
            url:'/projects/getdatauserprofile',
            method:'get',
            params:query
        })
    }
    static getcountprojects(query){
        return request({
            url:'/projects/getcountprojects',
            method:'get',
            params:query
        })
    }
    static getprojectsvisiblepublic(query){
        return request({
            url:'/projects/getprojectsvisiblepublic',
            method:'get',
            params:query
        })
    }
    static deleteproject(query){
        return request({
            url:'/projects/deleteproject',
            method:'delete',
            params:query
        })
    }
}
export default ProjectService